export default __webpack_public_path__ + "static/media/Partum_Novum_Logo_vector.b535a9f2.svg";